import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "h-full flex flex-col justify-between" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "mb-5 py-2 text-3xl font-bold text-gray-700 border-b border-secondary" }
const _hoisted_4 = { class: "wrapper grid grid-cols-2 gap-2 h-fit" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex-1" }
const _hoisted_7 = { class: "flex flex-1 mb-2" }
const _hoisted_8 = { class: "flex flex-col text-right" }
const _hoisted_9 = { class: "mb-2" }
const _hoisted_10 = {
  key: 0,
  class: "py-8 text-center text-gray-500"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "flex my-5 items-center gap-3 border-b border-secondary" }
const _hoisted_13 = { class: "py-2 text-3xl font-bold text-gray-700" }
const _hoisted_14 = {
  key: 0,
  class: "flex flex-col gap-3"
}
const _hoisted_15 = { class: "w-full bg-gray-50 table-auto" }
const _hoisted_16 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_17 = { class: "border text-sm text-gray-600 p-4 border-[#e5e5e5] w-10" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "border text-sm text-gray-600 p-4 border-[#e5e5e5]" }
const _hoisted_20 = { class: "border text-sm text-gray-600 p-4 border-[#e5e5e5]" }
const _hoisted_21 = { class: "border text-sm text-gray-600 p-4 border-[#e5e5e5]" }
const _hoisted_22 = {
  key: 1,
  class: "py-8 text-center text-gray-500"
}
const _hoisted_23 = {
  key: 2,
  class: "mt-auto"
}
const _hoisted_24 = {
  key: 3,
  class: "mt-auto"
}

import { useMortality } from "@/composables/tasks/mortality-check/useMortality";
import FooterActions from "@/components/v2/Tasks/Vaccination/Buttons/ActionButtons/FooterActions.vue";
import { ref, computed } from "vue";
import { GroupTag, TankGroup } from "@/types/v2";


export default /*@__PURE__*/_defineComponent({
  __name: 'TankView',
  setup(__props) {

const { activeTank, navigateToOverview, navigateToGroupView } = useMortality();
const overview = ref(false);

const calculateDeceased = (progressData: any[]): number => {
    if (Array.isArray(progressData)) {
        return progressData.reduce(
            (acc, item) => acc + (item.quantity > 0 ? item.quantity : 0),
            0
        );
    }
    return 0;
};

const calculatePercentage = (progressData: any[] = [], total = 0): string => {
    if (Array.isArray(progressData)) {
        const totalDeceased = progressData.reduce(
            (acc, item) => acc + (item.quantity > 0 ? item.quantity : 0),
            0
        );

        if (total > 0) {
            return ((totalDeceased / total) * 100).toFixed(2);
        }
    }
    return "0";
};

const flattenedGroups = computed(() => {
    if (!activeTank.value?.groups) return [];

    const result = [];

    for (const group of activeTank.value.groups) {
        if (Array.isArray(group.progressData) && group.progressData.length > 0) {
            for (const progress of group.progressData) {
                result.push({
                    ...group,
                    progressData: progress
                });
            }
        }
    }

    return result.reverse(); // Newest first
});

const generateTagString = (tags: GroupTag[]) => {
    if (!tags) return '';

    return tags.map(tag =>
        `<span style="display:inline-block; margin: 0 5px 5px 0; font-size:12px; text-align:center; padding:5px;
     color:${tag.textColor || 'white'}; border-radius:5px; background-color:${tag.backgroundColor}">
       ${tag.title}
     </span>`
    ).join('');
};

// Remove last mortality record
const removeLastItem = () => {
    if (!activeTank.value?.groups) return;

    const groupsWithData = activeTank.value.groups.filter(g =>
        Array.isArray(g.progressData) && g.progressData.length > 0
    );

    if (groupsWithData.length === 0) return;

    // Find group with most recent entry
    let targetGroup = groupsWithData[0];

    for (const group of groupsWithData) {
        if (group.progressData.length > targetGroup.progressData.length) {
            targetGroup = group;
        }
    }

    targetGroup.progressData.pop();
};

const saveTank = () => {
    if (activeTank.value) {
        activeTank.value.status = "completed";
    }
    toggleOverview();
};


const toggleOverview = (): void => {
    overview.value = !overview.value;
};

const handleBackClick = (): void => {
    navigateToOverview();
};

const handleGroupClick = (group: TankGroup): void => {
    if (activeTank.value) {
        navigateToGroupView(activeTank.value.key, group.key);
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!overview.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(activeTank)?.label), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeTank)?.groups, (group) => {
              return (_openBlock(), _createElementBlock("div", {
                key: group.key,
                class: "bg-primary p-3 cursor-pointer text-white shadow-md flex items-center justify-between",
                onClick: ($event: any) => (handleGroupClick(group))
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, [
                    _createElementVNode("strong", null, _toDisplayString(group.name), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.tags, (flag) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: flag.title,
                      style: _normalizeStyle({ background: flag.backgroundColor }),
                      class: "border border-white inline-flex mr-2 mb-2 text-xs p-1 rounded-md font-bold"
                    }, _toDisplayString(flag.title), 5))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, [
                    _cache[0] || (_cache[0] = _createTextVNode(" Total: ")),
                    _createElementVNode("strong", null, _toDisplayString(group.amountInTank || group.count), 1),
                    _cache[1] || (_cache[1] = _createElementVNode("span", null, " / ", -1)),
                    _cache[2] || (_cache[2] = _createTextVNode(" Dead: ")),
                    _createElementVNode("strong", null, _toDisplayString(calculateDeceased(group.progressData)), 1)
                  ]),
                  _createElementVNode("span", null, [
                    _cache[3] || (_cache[3] = _createTextVNode(" Rate: ")),
                    _createElementVNode("strong", null, _toDisplayString(calculatePercentage(group.progressData, group.amountInTank || group.count)) + "% ", 1)
                  ])
                ])
              ], 8, _hoisted_5))
            }), 128))
          ]),
          (!_unref(activeTank)?.groups || _unref(activeTank).groups.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, " This tank has no groups. "))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (overview.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h1", _hoisted_13, _toDisplayString(_unref(activeTank)?.label) + " - Overview ", 1)
          ]),
          (flattenedGroups.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("table", _hoisted_15, [
                  _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { class: "px-6 py-3 text-left text-sm font-medium text-gray-500 capitalize tracking-wider w-10" }, "#"),
                      _createElementVNode("th", { class: "px-6 py-3 text-left text-sm font-medium text-gray-500 capitalize tracking-wider" }, "Fish Group"),
                      _createElementVNode("th", { class: "px-6 py-3 text-left text-sm font-medium text-gray-500 capitalize tracking-wider" }, "Reason"),
                      _createElementVNode("th", { class: "px-6 py-3 text-left text-sm font-medium text-gray-500 capitalize tracking-wider" }, "Quantity"),
                      _createElementVNode("th", { class: "px-6 py-3 text-left text-sm font-medium text-gray-500 capitalize tracking-wider" }, "Comment")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flattenedGroups.value, (group, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_17, _toDisplayString(index + 1), 1),
                        _createElementVNode("td", {
                          class: "border text-sm text-gray-600 p-4 border-[#e5e5e5]",
                          innerHTML: generateTagString(group.tags)
                        }, null, 8, _hoisted_18),
                        _createElementVNode("td", _hoisted_19, _toDisplayString(group.progressData.reason), 1),
                        _createElementVNode("td", _hoisted_20, _toDisplayString(group.progressData.quantity), 1),
                        _createElementVNode("td", _hoisted_21, _toDisplayString(group.progressData.comment), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_22, " No mortality data has been recorded for this tank. "))
        ]))
      : _createCommentVNode("", true),
    (!overview.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createVNode(FooterActions, null, {
            start: _withCtx(() => [
              _createElementVNode("button", {
                class: "w-full",
                onClick: toggleOverview
              }, " Overview ")
            ]),
            end: _withCtx(() => [
              _createElementVNode("button", {
                class: "w-full",
                onClick: handleBackClick
              }, " Back ")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (overview.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createVNode(FooterActions, null, {
            start: _withCtx(() => [
              _createElementVNode("button", {
                class: "w-full",
                onClick: removeLastItem
              }, " Remove last ")
            ]),
            middle: _withCtx(() => [
              _createElementVNode("button", {
                class: "w-full",
                onClick: toggleOverview
              }, " Back ")
            ]),
            end: _withCtx(() => [
              _createElementVNode("button", {
                class: "w-full",
                onClick: saveTank
              }, " Save tank ")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})